import {
  ButtonSecondary,
  ButtonSize,
  ClickOutsideDetector,
  IconArrowRight,
  IconBlock,
  IconDownload,
  IconLoader,
  IconSelected,
  IconTrash,
  PermissionEnum,
} from '@ui/src';
import { NewApplicationStatus } from '../../../../../hoc/common/types';
import { ApplicationDocumentStatus } from '../../../../../hoc/new-application/types';
import { DocumentsControlsTypes } from '../types';

import cn from '../styles.module.css';

const DocumentsControls = ({
  selectedDocumentsCounts,
  cofSelectedDocumentsCount,
  corporateSelectedDocumentsCount,
  applicationStatus,
  setMenuVisible,
  menuVisible,
  moveInProgress,
  isCof,
  isCorporate,
  allowedDocumentsCategories,
  changeDocumentCategoryAction,
  activePermissions,
  statusChangeInProgress,
  selectedStatus,
  setSelectedStatus,
  changeDocumentStatusAction,
  isLoading,
  getFiles,
  setDeletePopupVisible,
}: DocumentsControlsTypes) => {
  let menuButtonDisabled = selectedDocumentsCounts === 0;

  if (isCof) {
    menuButtonDisabled = cofSelectedDocumentsCount === 0;
  } else if (isCorporate) {
    menuButtonDisabled = corporateSelectedDocumentsCount === 0;
  }

  return (
    <>
      {(selectedDocumentsCounts > 0 ||
        cofSelectedDocumentsCount > 0 ||
        corporateSelectedDocumentsCount > 0) && (
        <>
          {applicationStatus !== NewApplicationStatus.ACCEPTED &&
            applicationStatus !== NewApplicationStatus.DECLINED && (
              <div className={cn.documentsControlSeparator} />
            )}
          <div className={cn.selectedDocumentsMoveWrapper}>
            {applicationStatus !== NewApplicationStatus.ACCEPTED &&
              applicationStatus !== NewApplicationStatus.DECLINED && (
                <>
                  <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
                    <>
                      <ButtonSecondary
                        className={`button-white ${cn.controlButton}`}
                        icon={<IconArrowRight />}
                        size={ButtonSize.SMALL}
                        text={moveInProgress ? 'Loading...' : 'Move to group'}
                        onClick={() => setMenuVisible(!menuVisible)}
                        disabled={menuButtonDisabled}
                        tabIndex={-1}
                      />
                      {menuVisible && (
                        <ul className={cn.selectedDocumentsMenu}>
                          <li className={cn.selectedDocumentsMenuTitle}>
                            {`Which group to move ${isCof ? cofSelectedDocumentsCount : selectedDocumentsCounts} documents to?`}
                          </li>

                          {allowedDocumentsCategories
                            ?.filter(
                              (item) => !item.id.includes('identification'),
                            )
                            ?.map((item) => (
                              <li key={item.id}>
                                <button
                                  type="button"
                                  className={cn.selectedDocumentsMenuButton}
                                  onClick={() => {
                                    changeDocumentCategoryAction(item.id);
                                    setMenuVisible(false);
                                  }}
                                  tabIndex={-1}
                                >
                                  {item.name}
                                  <div>
                                    Move <IconArrowRight />
                                  </div>
                                </button>
                              </li>
                            ))}
                        </ul>
                      )}
                    </>
                  </ClickOutsideDetector>
                  {activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                  ) && (
                    <>
                      <ButtonSecondary
                        className={`button-white ${cn.controlButton}`}
                        text={
                          statusChangeInProgress &&
                          selectedStatus === ApplicationDocumentStatus.ACCEPTED
                            ? 'Loading...'
                            : 'Accept'
                        }
                        tabIndex={-1}
                        icon={
                          statusChangeInProgress &&
                          selectedStatus ===
                            ApplicationDocumentStatus.ACCEPTED ? (
                            <IconLoader />
                          ) : (
                            <IconSelected />
                          )
                        }
                        size={ButtonSize.SMALL}
                        onClick={() => {
                          setSelectedStatus(ApplicationDocumentStatus.ACCEPTED);

                          changeDocumentStatusAction(
                            ApplicationDocumentStatus.ACCEPTED,
                          );
                        }}
                        disabled={statusChangeInProgress}
                      />
                      <ButtonSecondary
                        className={`button-white ${cn.controlButton}`}
                        text={
                          statusChangeInProgress &&
                          selectedStatus === ApplicationDocumentStatus.REJECTED
                            ? 'Loading...'
                            : 'Reject'
                        }
                        icon={
                          statusChangeInProgress &&
                          selectedStatus ===
                            ApplicationDocumentStatus.REJECTED ? (
                            <IconLoader />
                          ) : (
                            <IconBlock />
                          )
                        }
                        tabIndex={-1}
                        onClick={() => {
                          setSelectedStatus(ApplicationDocumentStatus.REJECTED);

                          changeDocumentStatusAction(
                            ApplicationDocumentStatus.REJECTED,
                          );
                        }}
                        size={ButtonSize.SMALL}
                        disabled={statusChangeInProgress}
                      />
                    </>
                  )}
                </>
              )}
            <ButtonSecondary
              className={`button-white ${cn.controlButton}`}
              text="Downloads"
              icon={isLoading ? <IconLoader /> : <IconDownload />}
              size={ButtonSize.SMALL}
              onClick={getFiles}
              disabled={isLoading}
              tabIndex={-1}
            />
            {applicationStatus !== NewApplicationStatus.ACCEPTED &&
              applicationStatus !== NewApplicationStatus.DECLINED &&
              activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
              ) && (
                <ButtonSecondary
                  className={`button-white ${cn.controlButton}`}
                  text="Delete"
                  icon={<IconTrash />}
                  size={ButtonSize.SMALL}
                  onClick={() => setDeletePopupVisible(true)}
                  tabIndex={-1}
                />
              )}
          </div>
        </>
      )}
    </>
  );
};

export default DocumentsControls;
